import { render, staticRenderFns } from "./releaseTypes.vue?vue&type=template&id=ce22f2d2"
import script from "./releaseTypes.vue?vue&type=script&lang=js"
export * from "./releaseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports